export default {
	DEFAULT_VENDOR_LIMIT_SHOW: 1 as number,
	DEFAULT_VENDOR_LIMIT_FETCH: 4 as number,
	DEFAULT_SEARCH_RADIUS_VALUE: 25 as number,
	ENABLED_IVOL_VALUE: 1 as number,

	FETCH_SIMILAR_VENDORS: 'FETCH_SIMILAR_VENDORS',
	FETCH_SIMILAR_VENDORS_SUCCESS: 'FETCH_SIMILAR_VENDORS_SUCCESS',
	FETCH_SIMILAR_VENDORS_ERROR: 'FETCH_SIMILAR_VENDORS_ERROR',

	FETCH_BOW_VENDORS: 'FETCH_BOW_VENDORS',
	FETCH_BOW_VENDORS_SUCCESS: 'FETCH_BOW_VENDORS_SUCCESS',
	FETCH_BOW_VENDORS_ERROR: 'FETCH_BOW_VENDORS_ERROR',

	FETCH_PVREC_ANON_VENDORS: 'FETCH_PVREC_ANON_VENDORS',
	FETCH_PVREC_ANON_VENDORS_SUCCESS: 'FETCH_PVREC_ANON_VENDORS_SUCCESS',
	FETCH_PVREC_ANON_VENDORS_ERROR: 'FETCH_PVREC_ANON_VENDORS_ERROR',

	FETCH_PAIVER_VENDORS: 'FETCH_PAIVER_VENDORS',
	FETCH_PAIVER_VENDORS_SUCCESS: 'FETCH_PAIVER_VENDORS_SUCCESS',
	FETCH_PAIVER_VENDORS_ERROR: 'FETCH_PAIVER_VENDORS_ERROR',

	FETCH_PVREC_CROSS_CAT_VENDORS: 'FETCH_PVREC_CROSS_CAT_VENDORS',
	FETCH_PVREC_CROSS_CAT_VENDORS_SUCCESS:
		'FETCH_PVREC_CROSS_CAT_VENDORS_SUCCESS',
	FETCH_PVREC_CROSS_CAT_VENDORS_ERROR: 'FETCH_PVREC_CROSS_CAT_VENDORS_ERROR',

	FETCH_SIMILAR_VENDORS_BASED_ON_ACTIVITY:
		'FETCH_SIMILAR_VENDORS_BASED_ON_ACTIVITY',
	FETCH_SIMILAR_VENDORS_BASED_ON_ACTIVITY_SUCCESS:
		'FETCH_SIMILAR_VENDORS_BASED_ON_ACTIVITY_SUCCESS',
	FETCH_SIMILAR_VENDORS_BASED_ON_ACTIVITY_ERROR:
		'FETCH_SIMILAR_VENDORS_BASED_ON_ACTIVITY_ERROR',

	CLEAR_RECOMMENDED_VENDORS: 'CLEAR_RECOMMENDED_VENDORS',
} as const;
